export default "__VITE_ASSET__1e6a117d__"